import { FC, useState } from 'react';
import { registerUser } from '../services/authService'; // Import the register service
import { text } from '../text';
import { hooks } from '../hooks';
import { utils } from '../utils';
import { custom } from '../custom';
import { svg } from '../assets/svg';
import { theme } from '../constants';
import { components } from '../components';
import { CircularProgress } from '@mui/material';
import Main_Logo_green from '../assets/images/Main_Logo_green.png';
import toast from 'react-hot-toast';

export const SignUp: FC = (): JSX.Element => {
  const navigate = hooks.useAppNavigate();
  const [workplaceId, setWorkplaceId] = useState('1'); // Assuming a default value for simplicity
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleSignUp = async () => {
    if (!validateForm()) return;
    if (password !== passwordConfirmation) {
      alert("Passwords don't match");
      return;
    }

    setLoading(true);

    try {
      const formattedPhone = '251' + phone.slice(1);

      const response = await registerUser({
        workplace_id: workplaceId,
        first_name: firstName,
        last_name: lastName,
        email,
        password,
        password_confirmation: passwordConfirmation,
        phone: formattedPhone,
      });
      toast.success('Registration successful:', response);
      navigate('/SignUpAccountCreated');
      // console.log('Registration successful:', response);
    } catch (error) {
      const err = error as Error;
      // toast.error(err.message);

      // console.log(error);
      // console.error('Registration failed:', error);
      toast.error(err.message ?? `Registration failed. Please try again.`);
    } finally {
      setLoading(false);
    }
  };
  const validateForm = (): boolean => {
    if (!firstName.trim()) {
      alert('First name is required');
      return false;
    }
    if (!lastName.trim()) {
      alert('Last name is required');
      return false;
    }
    if (!email.trim()) {
      alert('Email is required');
      return false;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      alert('Please enter a valid email');
      return false;
    }
    if (!phone.trim()) {
      alert('Phone number is required');
      return false;
    }
    if (!/^0\d{9}$/.test(phone)) {
      alert('Phone number must start with 0 and be exactly 10 digits');
      return false;
    }
    if (!password) {
      alert('Password is required');
      return false;
    }
    if (password.length < 6) {
      alert('Password must be at least 6 characters');
      return false;
    }
    if (password !== passwordConfirmation) {
      alert("Passwords don't match");
      return false;
    }

    return true;
  };

  const renderContent = (): JSX.Element => {
    return (
      <main
        className='container'
        style={{
          padding: '50px 20px 20px 20px',
          marginTop: 10,
          border: '1px solid #E8EFF4',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: 10,
          }}
        >
          <img
            src={Main_Logo_green}
            alt='Logo'
            style={{ width: '270px', height: '150px', cursor: 'pointer' }}
            onClick={() => navigate('/SignIn')}
          />
        </div>
        <text.H1
          style={{ marginBottom: 40, display: 'flex', justifyContent: 'center' }}
        >
          Sign up
        </text.H1>
        <custom.InputField
          label='First Name'
          placeholder='Olivia'
          icon={<svg.InputCheckSvg />}
          containerStyle={{
            marginBottom: 20,
            border: '1px solid #E8EFF4',
            borderRadius: '10px',
          }}
          onChange={(e) => setFirstName(e.target.value)}
        />
        <custom.InputField
          label='Last Name'
          placeholder='Bennett'
          icon={<svg.InputCheckSvg />}
          containerStyle={{
            marginBottom: 20,
            border: '1px solid #E8EFF4',
            borderRadius: '10px',
          }}
          onChange={(e) => setLastName(e.target.value)}
        />
        <custom.InputField
          label='Email'
          icon={<svg.InputCheckSvg />}
          placeholder='oliviabennett@mail.com'
          containerStyle={{
            marginBottom: 20,
            border: '1px solid #E8EFF4',
            borderRadius: '10px',
          }}
          onChange={(e) => setEmail(e.target.value)}
        />
        <custom.InputField
          label='Phone Number'
          icon={<svg.InputCheckSvg />}
          placeholder='09********'
          containerStyle={{
            marginBottom: 20,
            border: '1px solid #E8EFF4',
            borderRadius: '10px',
          }}
          onChange={(e) => setPhone(e.target.value)}
        />
        <custom.InputField
          clickable={true}
          label='Password'
          placeholder='••••••••'
          // type='password'
          // icon={<svg.EyeOffSvg />}
          type={showPassword ? 'text' : 'password'}
          icon={showPassword ? <svg.EyeSvg /> : <svg.EyeOffSvg />}
          onIconClick={() => setShowPassword(!showPassword)}
          containerStyle={{
            marginBottom: 20,
            border: '1px solid #E8EFF4',
            borderRadius: '10px',
          }}
          onChange={(e) => setPassword(e.target.value)}
        />
        <custom.InputField
          clickable={true}
          // type='password'
          label='Confirm Password'
          placeholder='••••••••'
          // icon={<svg.EyeOffSvg />}
          type={showConfirmPassword ? 'text' : 'password'}
          icon={showConfirmPassword ? <svg.EyeSvg /> : <svg.EyeOffSvg />}
          onIconClick={() => setShowConfirmPassword(!showConfirmPassword)}
          containerStyle={{
            marginBottom: 20,
            border: '1px solid #E8EFF4',
            borderRadius: '10px',
          }}
          onChange={(e) => setPasswordConfirmation(e.target.value)}
        />
        {loading ? (
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <CircularProgress color='inherit' />
          </div>
        ) : (
          <components.Button
            title='Sign up'
            onClick={handleSignUp}
            // loading={loading}
            style={{
              marginBottom: 20,
              background: theme.colors.mainColor,
              cursor: 'pointer',
            }}
          />
        )}
        <div style={{ ...utils.rowCenter(), marginBottom: 50 }}>
          <text.T16 style={{ marginRight: 4 }}>Already have an account?</text.T16>
          <text.T16
            onClick={() => navigate('/SignIn')}
            style={{ color: theme.colors.mainColor, cursor: 'pointer' }}
          >
            Sign in.
          </text.T16>
        </div>
      </main>
    );
  };

  return <>{renderContent()}</>;
};
